<div id="scrn-table">
  <div id="scrn-cell">
    <div id="scrn-p">

      <header id="scrn-h">
        <div  *ngIf="templateSettings.header" class="subtitle-strap">
         {{ templateSettings.header }}
        </div>
      </header>

      <div id="scrn-c">
        <div class="columns">

<!-- Help Container -->
<div id="scrn" class="content-container">
<div class="message-container">

<ng-container *ngIf="jsonData==undefined">
  <div class="form-control">
   <p class="form-paragraph">{{ templateSettings.formParagraph }}</p>
  </div>

  <form id="scrn-c" [formGroup]="passwordForm" (ngSubmit)="submitForm(passwordForm.value)" novalidate="novalidate">

    <div *ngIf="messageCopy" class="{{ messageClass }}" role="Message">{{ messageCopy }}</div>

  <div class="column">

    <div class="form-control">
    <label for="password">{{ locale.confirmPassword }}</label>
    <input (click)="onClickInput()" type="password" class="input-control show-pad" [formControl]="passwordForm.controls['password']"/>
    <div class="validation-error" *ngIf="(resetPasswordSubmitted || passwordForm.controls['password'].dirty) && !passwordForm.controls['password'].valid">
      <div class="form-hint">
        <div>{{ locale.pleaseConfirmPassword }}</div>
      </div>
    </div>
    </div>
  <div class="form-control">
    <button *ngIf="templateSettings.submit" type="submit" class="input-control button" [disabled]="formSubmitted"> {{ templateSettings.submit }}</button>
  </div>
  </div>

  </form>



</ng-container>

<ng-container *ngIf="jsonData!=undefined">
  <div class="{{ messageClass }}" role="Message">{{ locale.successMessage }}</div>
  <div class="form-control">
    <p>{{ locale.complianceGDPR }}<a [href]="jsonData" download="myunichoices-data.json.txt">{{ locale.downloadFile }}</a>{{ locale.suppliedBy }}</p>
  </div>
</ng-container>

  <div id="your-information">

    <h4>{{ locale.yourInformation }}</h4>

    <div class="clear-fix">

      <div id="headers">
        <p>{{ locale.personalDetailsHeader }}</p>
        <p>{{ locale.questionAnswersHeader }}</p>
        <p>{{ locale.shortlistHeader }}</p>
        <p>{{ locale.viewedCoursesHeader }}</p>
        <p>{{ locale.activityLogHeader }}</p>
      </div>

      <div id="details">
        <p>{{ locale.personalDetailsBody }}</p>
        <p>{{ locale.questionAnswersBody }}</p>
        <p>{{ locale.shortlistBody }}</p>
        <p>{{ locale.viewedCoursesBody }}</p>
        <p>{{ locale.activityLogBody }}</p>
      </div>

    </div>

  </div>

</div>
</div>

        </div>
      </div>

      <footer id="scrn-f">
        <div class="cancel">
          <a (click)="goBack()">Go back</a>
        </div>
      </footer>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/_shared/account/base-confirm-password-form/base-confirm-password-form.component.html